<div class="flex items-center justify-left sub-header w-full">

    <p class="pl-[88px]">
        Custom
    </p>

    <p class="pl-[101px] sub-path">

        Stage 2> Custom

    </p>

</div>
<app-accordion></app-accordion>
<div class="relative h-[100vh] bg-cover bg-center text-white flex items-center justify-center bg-[rgb(76,151,212)]"
    style="background-image: url('assets/images/home_bg.jpeg')">
    <div class="absolute inset-0 bg-[#272c36] bg-opacity-80 z-10"></div>
    <div class="w-full h-full z-20 flex mt-[50vh] justify-center">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[64.26px] text-center ml-[20vw]">
            
            <div class="group">
                <div class="transform group-hover:-translate-y-1 transition-transform duration-300 w-[327px] h-[327px] flex justify-center items-center flex-col cursor-pointer">
                    
                    <p class="text-[#f1f3f5] text-[24px] pb-[8px] font-bold"
                        style="text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)">
                        AI Generated
                    </p>
            
                    <!-- Rhombus with image in the center -->
                    <div class="bg-[#f1f3f5] w-[150px] h-[150px] flex justify-center items-center" style="border-radius: 50%;">
                        <img src="assets/images/development.png" alt="Development" class="w-[100px] h-[100px]">
                    </div>
                </div>
            </div>
            
            <div class="group" (click) = "navigateToManualSetup()">
                <div class="transform group-hover:-translate-y-1 transition-transform duration-300 w-[327px] h-[327px] flex justify-center items-center flex-col cursor-pointer">
                    
                    <p class="text-[#f1f3f5] text-[24px] pb-[8px] font-bold"
                        style="text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)">
                        Manual
                    </p>
            
                    <!-- Rhombus with image in the center -->
                    <div class="bg-[#f1f3f5] w-[150px] h-[150px] flex justify-center items-center" style="border-radius: 50%;">
                        <img src="assets/images/development.png" alt="Development" class="w-[100px] h-[100px]">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
